import {
  Button,
  Input,
  Label,
  Toaster,
  Spinner,
} from "@fluentui/react-components";
import { ChangeEvent, useEffect, useState } from "react";
import { Edit24Filled, DismissFilled } from "@fluentui/react-icons";
import _ from "lodash";
import "./style.css";
import apiServices from "../../service";
import {
  formatedDate,
  formatedDate2,
  formatedTime,
  getAssetTypeByCaseTypeId,
  getpolicyCategoryByCaseType,
  isObjectEmpty,
} from "../../utils";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import moment from "moment";
import TimePicker from "react-datepicker";
import TextEditor from "../../components/TextEditor";
import CreatableSelect from "react-select/creatable";
import { formBuilder } from "../../utils/formGenerator";
import CreatableSelectionList from "../../components/Creatablelist";
import OverlayLoader from "../../components/OverlayLoader";
import { setFormData } from "../../redux/formUpdateReducer";
import ContentLoader from "../../components/Loader/ContentLoader";
import ASCButton from "../../components/Button";
import { useToastMessage } from "../../components/ToastMessage/ToastMessage";
import DynamicDatePicker from "../../components/ControlledDatePicker/dynamicDatepicker";
import { parse } from "path";

const ActionListForm = (props: any) => {
  const [mode, setMode] = useState("edit");
  const dispatch: AppDispatch = useDispatch();
  const { showToast, toasterId } = useToastMessage();
  const [formField, setFormField] = useState<any | {}>({});
  const [startDate, setStartDate] = useState(
    props.data?.time ? new Date(props.data.time) : new Date()
  );
  const validateSchema = Yup.object().shape({});
  const [isFieldUpdated, setIsFieldUpdated] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [newlyAddedSelectOptions, setNewlyAddedSelectOptions] = useState<any>(
    []
  );
  const [selectFieldOptionLabels, setSelectFieldOptionLabels] = useState<any>(
    []
  );
  const objFormSettings = useSelector((state: RootState) => state.formSettings);
  const [selectFieldOptions, setSelectFieldOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [newDate, setNewDate] = useState(
    formField?.date ? new Date(formField.date) : null
  );

  useEffect(() => {
    if (formField.time) {
      setStartDate(new Date(formField.time));
    } else {
      setStartDate(new Date()); // Fallback to current time if formField.time is not set
    }
  }, [formField.time]);

  // Selection list
  const getSelectionListOptions = async () => {
    try {
      let fieldLbl = "";
      if (props.activeRowItem.category === "Client Action") {
        fieldLbl =
          "appointment_type:ModifiableList,appointment_assigned:ModifiableList,appointment_status:ModifiableList";
      } else if (
        props.activeRowItem.category === "Asset(Investment) Review" ||
        props.activeRowItem.category === "Asset(Banks) Review" ||
        props.activeRowItem.category === "Asset(Shares) Review" ||
        props.activeRowItem.category === "Asset(Home) Review" ||
        props.activeRowItem.category === "Mortgage Review Date" ||
        props.activeRowItem.category === "Loan Review Date" ||
        props.activeRowItem.category === "Credit Card Review Date" ||
        props.activeRowItem.category === "Policy Review Date"
      ) {
        fieldLbl = "review_assigned:ModifiableList";
      } else if (props.activeRowItem.category === "Client Review") {
        fieldLbl = "review_assigned:ModifiableList";
      } else {
        fieldLbl =
          "business_assigned:ModifiableList,business_status:ModifiableList";
      }

      if (fieldLbl !== "") {
        const res = await apiServices.selectionList.getOptions(fieldLbl);
        if (res.data && res.data.data) {
          setSelectFieldOptions(res.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const newSelectOptionAdded = (
    field: string,
    selectionLabel: string,
    selectionType: string,
    options: any,
    operation: string
  ) => {
    if (operation === "remove") {
      const filteredRes = newlyAddedSelectOptions.filter(
        (item: any) => item.field !== field
      );

      setNewlyAddedSelectOptions(filteredRes);
    } else {
      let newVall: any = {
        type: selectionType,
        options: [],
      };
      newVall["options"].push({
        field: selectionLabel,
        label: options.label,
        value: options.value,
      });

      setNewlyAddedSelectOptions((prev: any) => [...prev, newVall]);
    }
  };
  const AddSelectOptions = () => {
    if (newlyAddedSelectOptions.length > 0) {
      apiServices.selectionList
        .addOptions(newlyAddedSelectOptions)
        .then((response: any) => { })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    getSelectionListOptions();
  }, [props.data]);
  useEffect(() => {
    if (props) {
      const areEqual = _.isEqual(props.data, formField);
      setIsFieldUpdated(!areEqual);
    }
  }, [formField]);
  useEffect(() => {
    setFormField(props.data);
  }, [props.data]);
  const formik = useFormik({
    initialValues: props.data,
    validationSchema: validateSchema,
    onSubmit: (values, { resetForm }) => {
      updateClientData();
    },
  });
  const handleSubmit = (values: any) => { };
  function onChange(e: ChangeEvent<HTMLInputElement>) {
    setFormField({ ...formField, [e.target.name]: e.target.value });
  }

  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD-MM-YYYY");
  };
  const updateClientData = () => {
    let newData;

    if (props.activeRowItem.category === "Client Action") {
      setLoading(true);
      newData = {
        contacts_client_action: {
          customer_id: formField.customer_id,
          appointment_date: formatedDate2(formField.date) || "",
          appointment_time: formField.time,
          appointment_type: formField.type,
          appointment_status: formField.status,
          appointment_assigned: formField.assigned,
          appointment_note: formField.description,
        },
      };

      apiServices.contactClientAction
        .updateFactFindNote(
          formField.customer_id,
          formField.appointment_id,
          newData
        )
        .then((response: any) => {
          setLoading(false);
          if (!response.data.isError) {
            AddSelectOptions();
            props.showToast("Action Updated Successfully", "", "success");
            setTimeout(() => {
              props.cancelPopup();
              props.getActionListData();
            }, 2000);
          } else {
            props.showToast("Something went wrong", "", "error");
          }
        })
        .catch((error: Error) => {
          setLoading(false);
          props.showToast("Something went wrong", "", "error");
        });
    } else if (props.activeRowItem.category === "Client Review") {
      setLoading(true);
      newData = {
        administration: {
          customer_id: formField.customer_id,
          review_interval: parseInt(formField.review_interval),
          review_note: formField.review_reason,
          review_completed: formField.review_completed || "",
          review_date: formField.review_date || "",
          review_assigned: formField.review_assigned,
          consultant_id: formField.consultant_id,
          consultant: formField.consultant,
        },
      };
      apiServices.client
        .updateClient(formField.customer_id, newData)
        .then((response: any) => {
          setLoading(false);
          if (!response.data.isError) {
            props.showToast("Action Updated Successfully", "", "success");
            AddSelectOptions();
            setTimeout(() => {
              props.getActionListData();
              props.cancelPopup();
            }, 3000);
          } else if (response.data.isError) {
            if (
              response.data.error &&
              Object.keys(response.data.error).length !== 0
            ) {
              let errorMessage = "";

              if (Array.isArray(response.data.error.message)) {
                errorMessage = response.data.error.message.join("\n");
              } else {
                errorMessage = response.data.error.message;
              }

              props.showToast(errorMessage, "", "error");
            }
          } else {
            props.showToast("Something went wrong", "", "error");
          }
        })
        .catch((e: Error) => {
          setLoading(false);
          console.log(e);
        });
    } else if (props.activeRowItem.category === "Case Tracking Action") {
      setLoading(true);
      if (formField.business_category === 2) {
        newData = {
          asset_investment_actions: {
            customer_id: formField.customer_id,
            business_date: formField.action_date || "",
            business_action: formField.description,
            business_category: 2,
            business_status: formField.status,
            business_assigned: formField.assigned,
            case_id: formField.case_id,
          },
        };

        apiServices.Actions.updateActions(formField.business_id, newData)

          .then((response) => {
            setLoading(false);
            if (!response.data.isError) {
              props.showToast("Action Updated Successfully", "", "success");
              AddSelectOptions();

              setTimeout(() => {
                props.cancelPopup();
                props.getActionListData();
              }, 3000);
              setMode("view");
            } else {
              props.showToast("Something went wrong", "", "error");
            }
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            props.showToast(err.message, "", "error");
          });
      } else if (formField.business_category === 6) {
        newData = {
          liabilities_mortgages_actions: {
            customer_id: formField.customer_id,
            business_date: formField.action_date || "",
            business_action: formField.description,
            business_category: 6,
            business_status: formField.status,
            business_assigned: formField.assigned,
            case_id: formField.case_id,
          },
        };
        apiServices.Actions.updateActions(formField.business_id, newData)
          .then((response) => {
            setLoading(false);
            if (!response.data.isError) {
              props.showToast("Action Updated Successfully", "", "success");
              AddSelectOptions();

              setTimeout(() => {
                props.getActionListData();
                props.cancelPopup();
              }, 3000);
            } else {
              props.showToast("Something went wrong", "", "error");
            }
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            props.showToast(err.message, "", "error");
          });
      } else if (formField.business_category === 7) {
        newData = {
          liabilities_loan_hire_purchase_actions: {
            customer_id: formField.customer_id,
            business_date: formField.action_date || "",
            business_action: formField.description,
            business_category: 7,
            business_status: formField.status,
            business_assigned: formField.assigned,
            case_id: formField.case_id,
          },
        };
        apiServices.Actions.updateActions(formField.business_id, newData)
          .then((response) => {
            setLoading(false);
            if (!response.data.isError) {
              props.showToast("Action Updated Successfully", "", "success");
              AddSelectOptions();

              setTimeout(() => {
                props.getActionListData();
                props.cancelPopup();
              }, 3000);
            } else {
              props.showToast("Something went wrong", "", "error");
            }
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            props.showToast(err.message, "", "error");
          });
      } else if (formField.business_category === 1) {
        if (formField.case_type === "Life Assurance") {
          newData = {
            policies_life_assurance_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };
          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
              props.showToast(err.message, "", "error");
            });
        } else if (formField.case_type === "Investments") {
          newData = {
            policies_investments_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };

          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
              props.showToast(err.message, "", "error");
            });
        } else if (formField.case_type === "Pensions") {
          newData = {
            policies_pensions_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };
          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
              props.showToast(err.message, "", "error");
            });
        } else if (formField.case_type === "General") {
          newData = {
            policies_general_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };
          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();
                setTimeout(() => {
                  props.cancelPopup();
                  props.getActionListData();
                }, 3000);
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              console.log(err);
              props.showToast(err.message, "", "error");
              setLoading(false);
            });
        } else if (formField.case_type === "Health Assurance") {
          newData = {
            policies_health_assurance_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };
          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
              props.showToast(err.message, "", "error");
            });
        } else if (formField.case_type === "Income Protection") {
          newData = {
            policies_income_protection_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };
          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else if (response.data.isError) {
                if (
                  response.data.error &&
                  Object.keys(response.data.error).length !== 0
                ) {
                  let errorMessage = "";

                  if (Array.isArray(response.data.error.message)) {
                    errorMessage = response.data.error.message.join("\n");
                  } else {
                    errorMessage = response.data.error.message;
                  }

                  props.showToast(errorMessage, "", "error");
                }
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
              props.showToast(err.message, "", "error");
            });
        } else if (formField.case_type === "Savings Plans") {
          newData = {
            policies_savings_plans_actions: {
              customer_id: formField.customer_id,
              business_date: formField.action_date || "",
              business_action: formField.description,
              business_category: 1,
              business_status: formField.status,
              business_assigned: formField.assigned,
              case_id: formField.case_id,
            },
          };
          apiServices.Actions.updateActions(formField.business_id, newData)
            .then((response) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else if (response.data.isError) {
                if (
                  response.data.error &&
                  Object.keys(response.data.error).length !== 0
                ) {
                  let errorMessage = "";

                  if (Array.isArray(response.data.error.message)) {
                    errorMessage = response.data.error.message.join("\n");
                  } else {
                    errorMessage = response.data.error.message;
                  }

                  props.showToast(errorMessage, "", "error");
                }
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
              props.showToast(err.message, "", "error");
            });
        } else {
          setLoading(false);
          props.showToast("Something went wrong", "", "error");
        }
      } else {
        setLoading(false);
        props.showToast("Something went wrong", "", "error");
      }
    } else {
      setLoading(true);
      if (
        props.activeRowItem.category === "Asset(Investment) Review" ||
        props.activeRowItem.category === "Asset(Home) Review" ||
        props.activeRowItem.category === "Asset(Banks) Review" ||
        props.activeRowItem.category === "Asset(Shares) Review"
      ) {
        const commonData = {
          customer_id: formField.customer_id,
          review_date: formatedDate2(formField.date) || "",
          review_interval: parseInt(formField.review_interval),
          review_reason: formField.review_reason,
          review_completed: formatedDate2(formField.review_completed) || "",
          review_assigned: formField.review_assigned,
          joint_indicator: formField.owner,
        };
        switch (props.activeRowItem.category) {
          case "Asset(Banks) Review":
            newData = { asset_banks_building_societies_review: commonData };
            break;
          case "Asset(Home) Review":
            newData = { asset_home_personal_review: commonData };
            break;
          case "Asset(Investment) Review":
            newData = { asset_investment_review: commonData };
            break;
          case "Asset(Shares) Review":
            newData = { asset_share_holdings_review: commonData };
            break;
          default:
            newData = null;
            break;
        }
        if (newData) {
          apiServices.assets
            .updateAsset(formField.caseId, newData)
            .then((response: any) => {
              setLoading(false);
              if (!response.data.isError) {
                AddSelectOptions();
                props.showToast("Action Updated Successfully", "", "success");
                // setMessages(response.data.message);

                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 2000);
              } else if (response.data.isError) {
                if (
                  response.data.error &&
                  Object.keys(response.data.error).length !== 0
                ) {
                  let errorMessage = "";

                  if (Array.isArray(response.data.error.message)) {
                    errorMessage = response.data.error.message.join("\n");
                  } else {
                    errorMessage = response.data.error.message;
                  }

                  props.showToast(errorMessage, "", "error");
                }
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((e: Error) => {
              console.log(e);
              setLoading(false);
              props.showToast("Something went wrong", "", "error");
            });
        }
      } else if (
        props.activeRowItem.category === "Credit Card Review Date" ||
        props.activeRowItem.category === "Loan Review Date" ||
        props.activeRowItem.category === "Mortgage Review Date"
      ) {
        setLoading(true);
        const commonData = {
          customer_id: formField.customer_id,
          review_date: formatedDate2(formField.date) || "",
          review_interval: parseInt(formField.review_interval),
          review_reason: formField.review_reason,
          review_completed: formatedDate2(formField.review_completed) || "",
          review_assigned: formField.review_assigned,
          joint_indicator: formField.owner,
        };

        switch (props.activeRowItem.category) {
          case "Credit Card Review Date":
            newData = { liabilities_credit_cards_review: commonData };
            break;
          case "Loan Review Date":
            newData = { liabilities_loan_hire_purchase_review: commonData };
            break;
          case "Mortgage Review Date":
            newData = { liabilities_mortgages_review: commonData };
            break;
          default:
            newData = null;
            break;
        }

        if (newData) {
          apiServices.liability
            .update(formField.caseId, newData)
            .then((response: any) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();
                setTimeout(() => {
                  props.getActionListData();
                  props.cancelPopup();
                }, 3000);
              } else if (response.data.isError) {
                if (
                  response.data.error &&
                  Object.keys(response.data.error).length !== 0
                ) {
                  let errorMessage = "";

                  if (Array.isArray(response.data.error.message)) {
                    errorMessage = response.data.error.message.join("\n");
                  } else {
                    errorMessage = response.data.error.message;
                  }

                  props.showToast(errorMessage, "", "error");
                }
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((e: Error) => {
              console.log(e);
              setLoading(false);
              props.showToast(e.message, "error");
            });
        }
      } else if (
        formField.case_type === "Life Assurance" ||
        formField.case_type === "Health Assurance" ||
        formField.case_type === "Pensions" ||
        formField.case_type === "Savings Plans" ||
        formField.case_type === "Investments" ||
        formField.case_type === "General" ||
        formField.case_type === "Income Protection"
      ) {
        const commonData = {
          customer_id: formField.customer_id,
          case_type: getpolicyCategoryByCaseType(formField.case_type),
          review_date: formatedDate2(formField.date) || "",
          review_interval: parseInt(formField.review_interval),
          review_reason: formField.review_reason,
          review_completed: formatedDate2(formField.review_completed) || "",
          review_assigned: formField.review_assigned,
          policy_holder: formField.owner,
        };

        switch (formField.case_type) {
          case "Life Assurance":
            newData = { policies_life_assurance_review: commonData };
            break;
          case "Health Assurance":
            newData = { policies_health_assurance_review: commonData };
            break;
          case "Savings Plans":
            newData = { policies_savings_plans_review: commonData };
            break;
          case "Investments":
            newData = { policies_investments_review: commonData };
            break;
          case "Income Protection":
            newData = { policies_income_protection_review: commonData };
            break;
          case "General":
            newData = { policies_general_review: commonData };
            break;
          case "Pensions":
            newData = { policies_pensions_review: commonData };
            break;
          default:
            newData = null;
            break;
        }

        if (newData) {
          setLoading(true);
          apiServices.policy
            .update(formField.caseId, newData)
            .then((response: any) => {
              setLoading(false);
              if (!response.data.isError) {
                props.showToast("Action Updated Successfully", "", "success");
                AddSelectOptions();
                setTimeout(() => {
                  props.cancelPopup();
                  props.getActionListData();
                }, 3000);
              } else if (response.data.isError) {
                if (
                  response.data.error &&
                  Object.keys(response.data.error).length !== 0
                ) {
                  let errorMessage = "";

                  if (Array.isArray(response.data.error.message)) {
                    errorMessage = response.data.error.message.join("\n");
                  } else {
                    errorMessage = response.data.error.message;
                  }

                  props.showToast(errorMessage, "", "error");
                }
              } else {
                props.showToast("Something went wrong", "", "error");
              }
            })
            .catch((e: Error) => {
              setLoading(false);
              console.log(e);
              props.showToast(e.message, "error");
            });
        }
      }
    }
  };

  function getLabel(caseType: any) {
    switch (caseType) {
      case "Banks/B Societies":
        return "Asset Review";
      case "Home/Personal":
        return "Asset Review";
      case "Unit-linked":
        return "Asset Review";
      case "Shares":
        return "Asset Review";
      case "Credit Cards":
        return "Liability Review";
      case "Loans/Lease/HP":
        return "Liability Review";
      case "Mortgages":
        return "Liability Review";
      default:
        return null;
    }
  }
  function getCategoryLabel(category: any) {
    switch (category) {
      case "Client Action":
        return "Client Action";
      case "Client Review":
        return "Client Review";
      case "Case Tracking Action":
        return "Case Action";
      case "Asset (Investment) Review":
        return "Asset Review";
      case "Asset (Shares)Review":
        return "Asset Review";
      case "Asset (Bank) Review":
        return "Asset Review";
      case "Asset (Home)Review":
        return "Asset Review";
      case "Mortgages Review Date":
        return "Liability Review";
      case "Loan Review Date":
        return "Liability Review";
      case "Credit Cards":
        return "Liability Review";
      default:
        return "policy Review";
    }
  }

  const parseTime = (
    timeString: string | undefined | null,
    fieldName?: string
  ): Date | null => {
    if (!timeString) return null;

    const time = String(timeString).trim();

    try {
      if (time.includes("T") && time.includes("Z")) {
        return new Date(time);
      }

      if (/^\d{1,2}:\d{1,2}(:\d{1,2})?$/.test(time)) {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        const date = new Date();
        date.setUTCHours(hours || 0, minutes || 0, seconds || 0, 0);
        return date;
      }

      const parsed = new Date(time);
      return isNaN(parsed.getTime()) ? null : parsed;
    } catch {
      return null;
    }
  };

  const handleClearDate = (fieldName: string) => () => {
    dispatch(setFormData());
    setFormField((prevState: any) => ({
      ...prevState,
      [fieldName]: null,
    }));
  };

  if (formField && Object.keys(formField).length !== 0) {
    return (
      <div>
        <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
        <div className="toast_message_main">
          <div className="actionlist_title">
            <Label size="large">
              Update Reminder -{" "}
              {props.isDetailDataLoading ? null : props.activeRowItem.category}
            </Label>
            <DismissFilled
              style={{ fontSize: "20px" }}
              onClick={() => props.cancelPopup()}
            />
          </div>
        </div>
        <div>
          {props.activeRowItem.category === "Client Action" && (
            <>
              <div className="case_action_main">
                <div className="settings-table-content-label">Date</div>
                <DynamicDatePicker
                  name="date"
                  border
                  label={null}
                  required={false}
                  disabled={false}
                  formik={{
                    values: {
                      date: formField.date ? new Date(formField.date) : null,
                    },
                    setFieldValue: (_name: string, value: any) => {
                      dispatch(setFormData());
                      setFormField((prevState: any) => ({
                        ...prevState,
                        date: value,
                      }));
                    },
                    setFieldTouched: () => { },
                    setFieldError: () => { },
                    errors: {},
                    touched: {},
                  }}
                />

                <div className="settings-table-content-label">Time</div>
                <div
                  style={{
                    border: "none",
                    width: "100%",
                    borderRadius: "5px",
                  }}
                >
                  <TimePicker
                    selected={formField.time ? parseTime(formField.time) : null}
                    onChange={(date: Date | null) => {
                      if (date) {
                        const formatDate = new Date(date);

                        setFormField({
                          ...formField,
                          time: formatDate.toISOString(),
                        });
                      } else {
                        setFormField({
                          ...formField,
                          time: null,
                        });
                      }
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                  />
                </div>
                <div className="settings-table-content-label">Type</div>
                <CreatableSelectionList
                  name="appointment_type"
                  selectionLabel="appointment_type"
                  selectFieldOptions={selectFieldOptions}
                  newSelectOptionAdded={newSelectOptionAdded}
                  selectionType="ModifiableList"
                  values={formField.type}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    // setFormField({ ...formField, contact_type: text });
                    setFormField({ ...formField, type: text });
                  }}
                />
                <div className="settings-table-content-label">Reason</div>
                <TextEditor
                  inputData={formField.description}
                  onChange={(text: string) => {
                    setFormField({ ...formField, description: text });
                  }}
                  name={"description"}
                />
                <div className="settings-table-content-label">Assigned</div>
                <CreatableSelectionList
                  name="appointment_assigned"
                  selectionLabel="assigned"
                  selectFieldOptions={selectFieldOptions}
                  newSelectOptionAdded={newSelectOptionAdded}
                  selectionType="ModifiableList"
                  values={formField.assigned}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    // setFormField({ ...formField, contact_type: text });
                    setFormField({ ...formField, assigned: text });
                  }}
                />
                <div className="settings-table-content-label">Status</div>
                <CreatableSelectionList
                  name="appointment_status"
                  selectionLabel="status"
                  selectFieldOptions={selectFieldOptions}
                  newSelectOptionAdded={newSelectOptionAdded}
                  selectionType="ModifiableList"
                  values={formField.status}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    // setFormField({ ...formField, contact_type: text });
                    setFormField({ ...formField, status: text });
                  }}
                />
              </div>
            </>
          )}

          {[
            "Asset(Banks) Review",
            "Asset(Home) Review",
            "Asset(Investment) Review",
            "Asset(Shares) Review",
            "Credit Card Review Date",
            "Loan Review Date",
            "Mortgage Review Date",
            "Policy Review Date",
          ].includes(props.activeRowItem.category) && (
              <>
                <div className="case_action_main">
                  <div className="settings-table-content-label">Date</div>

                  <DynamicDatePicker
                    name="date"
                    label={null}
                    border
                    required={false}
                    disabled={false}
                    formik={{
                      values: {
                        date: formField.date ? new Date(formField.date) : null,
                      },
                      setFieldValue: (_name: string, value: any) => {
                        dispatch(setFormData());
                        setFormField((prevState: any) => ({
                          ...prevState,
                          date: value,
                        }));
                      },
                      setFieldTouched: () => { },
                      setFieldError: () => { },
                      errors: {},
                      touched: {},
                    }}
                  />

                  <div className="settings-table-content-label">
                    Interval (Months)
                  </div>
                  <Input
                    onChange={onChange}
                    name={"review_interval"}
                    value={formField.review_interval}
                  />
                  <div className="settings-table-content-label">Note</div>
                  <TextEditor
                    inputData={formField.review_reason}
                    onChange={(text: string) => {
                      dispatch(setFormData());
                      setFormField({ ...formField, review_reason: text });
                    }}
                    name={"review_reason"}
                  />
                  <div className="settings-table-content-label">
                    Review Assigned
                  </div>
                  <CreatableSelectionList
                    name="review_assigned"
                    selectionLabel="review_assigned"
                    selectFieldOptions={selectFieldOptions}
                    newSelectOptionAdded={newSelectOptionAdded}
                    selectionType="ModifiableList"
                    values={formField.review_assigned}
                    onChange={(text: string) => {
                      dispatch(setFormData());
                      // setFormField({ ...formField, contact_type: text });
                      setFormField({ ...formField, review_assigned: text });
                    }}
                  />
                  <div className="settings-table-content-label">Completed</div>

                  <DynamicDatePicker
                    name="review_completed"
                    border
                    label={null}
                    required={false}
                    disabled={false}
                    formik={{
                      values: {
                        review_completed: formField.review_completed
                          ? new Date(formField.review_completed)
                          : null,
                      },
                      setFieldValue: (_name: string, value: any) => {
                        dispatch(setFormData());
                        setFormField((prevState: any) => ({
                          ...prevState,
                          review_completed: value || "",
                        }));
                      },
                      setFieldTouched: () => { },
                      setFieldError: () => { },
                      errors: {},
                      touched: {},
                    }}
                  />
                </div>
              </>
            )}
          {props.activeRowItem.category === "Case Tracking Action" && (
            <>
              <div className="case_action_main">
                <div className="settings-table-content-label">Date</div>

                <DynamicDatePicker
                  name="action_date"
                  border
                  label={null}
                  required={false}
                  disabled={false}
                  formik={{
                    values: {
                      action_date: formField.action_date
                        ? new Date(formField.action_date)
                        : null,
                    },
                    setFieldValue: (_name: string, value: any) => {
                      dispatch(setFormData());
                      setFormField((prevState: any) => ({
                        ...prevState,
                        action_date: value,
                      }));
                    },
                    setFieldTouched: () => { },
                    setFieldError: () => { },
                    errors: {},
                    touched: {},
                  }}
                />

                <div className="settings-table-content-label">Review</div>
                <TextEditor
                  inputData={formField.description}
                  onChange={(text: string) => {
                    setFormField({ ...formField, description: text });
                  }}
                  name={"description"}
                />
                <div className="settings-table-content-label">Assigned</div>
                <CreatableSelectionList
                  name="business_assigned"
                  selectionLabel="business_assigned"
                  selectFieldOptions={selectFieldOptions}
                  newSelectOptionAdded={newSelectOptionAdded}
                  selectionType="ModifiableList"
                  values={formField.assigned}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    // setFormField({ ...formField, contact_type: text });
                    setFormField({ ...formField, assigned: text });
                  }}
                />
                <div className="settings-table-content-label">Status</div>
                <CreatableSelectionList
                  name="business_status"
                  selectionLabel="business_status"
                  selectFieldOptions={selectFieldOptions}
                  newSelectOptionAdded={newSelectOptionAdded}
                  selectionType="ModifiableList"
                  values={formField.status}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    // setFormField({ ...formField, contact_type: text });
                    setFormField({ ...formField, status: text });
                  }}
                />
              </div>
            </>
          )}

          {props.activeRowItem.category === "Client Review" && (
            <>
              <div className="case_action_main">
                <div className="settings-table-content-label">
                  Interval(mnth)
                </div>
                <Input
                  onChange={onChange}
                  name={"review_interval"}
                  value={formField.review_interval}
                />
                <div className="settings-table-content-label">Note</div>
                <TextEditor
                  inputData={formField.review_reason}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    setFormField({ ...formField, review_reason: text });
                  }}
                  name={"review_reason"}
                />
                <div className="settings-table-content-label">
                  Review Assigned
                </div>
                <CreatableSelectionList
                  name="review_assigned"
                  selectionLabel="review_assigned"
                  selectFieldOptions={selectFieldOptions}
                  newSelectOptionAdded={newSelectOptionAdded}
                  selectionType="ModifiableList"
                  values={formField.review_assigned}
                  onChange={(text: string) => {
                    dispatch(setFormData());
                    // setFormField({ ...formField, contact_type: text });
                    setFormField({ ...formField, review_assigned: text });
                  }}
                />
                <div className="settings-table-content-label">Completed</div>

                <DynamicDatePicker
                  border
                  name="review_completed"
                  label={null}
                  required={false}
                  disabled={false}
                  formik={{
                    values: {
                      review_completed: formField.review_completed
                        ? new Date(formField.review_completed)
                        : null,
                    },
                    setFieldValue: (_name: string, value: any) => {
                      dispatch(setFormData());
                      setFormField((prevState: any) => ({
                        ...prevState,
                        review_completed: value || "",
                      }));
                    },
                    setFieldTouched: () => { },
                    setFieldError: () => { },
                    errors: {},
                    touched: {},
                  }}
                />

                <div className="settings-table-content-label">
                  Next Review Date
                </div>
                <DynamicDatePicker
                  border
                  name="review_date"
                  label={null}
                  required={false}
                  disabled={false}
                  formik={{
                    values: {
                      review_date: formField.review_date
                        ? new Date(formField.review_date)
                        : null,
                    },
                    setFieldValue: (_name: string, value: any) => {
                      dispatch(setFormData());
                      setFormField((prevState: any) => ({
                        ...prevState,
                        review_date: value,
                      }));
                    },
                    setFieldTouched: () => { },
                    setFieldError: () => { },
                    errors: {},
                    touched: {},
                  }}
                />
              </div>
            </>
          )}
        </div>
        <div className="button-end-popup">
          <Button
            shape="rounded"
            className="asc-button-primary"
            appearance="primary"
            type="submit"
            size="medium"
            icon={loading ? <Spinner size="tiny" /> : null}
            disabled={isFieldUpdated ? false : true}
            onClick={() => updateClientData()}
            style={{ marginRight: 6 }}
          >
            {loading ? "Processing..." : "Save"}
          </Button>
          <Button
            shape="rounded"
            appearance="secondary"
            type="submit"
            size="medium"
            onClick={() => props.cancelPopup()}
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  } else {
    return <ContentLoader style={{ minHeight: "50vh" }} />;
  }
};

export default ActionListForm;
